import React, { useImperativeHandle, forwardRef } from 'react';
import Section from '../Section';
import Input from '../Input';
import { Row, Col } from '../../styles/utils/Grid';
import { useInputState } from '../../hooks';
import Autocomplete from '../Autocomplete';
import { handleChange } from '../../utils/inputEvents';
import { required, validCnpj } from '../../utils/inputValidation';
import masks from '../../utils';

const PersonalDataPJ = (props, ref) => {
  const [
    corporateName,
    setCorporateName,
    corporateNameRef,
    validateCorporateName,
  ] = useInputState();
  const [cnpj, setCnpj, cnpjRef, validateCnpj] = useInputState();
  const [
    activity,
    setActivity,
    activityRef,
    validateActivity,
  ] = useInputState();
  const [income, setIncome, incomeRef, validateIncome] = useInputState();

  useImperativeHandle(ref, () => ({
    validate: () => {
      const isInvalid = [
        validateCorporateName,
        validateIncome,
        validateCnpj,
        validateActivity,
      ]
        .reverse()
        .reduce((acc, v) => {
          const invalid = v();
          return acc || invalid;
        }, false);

      return {
        invalid: isInvalid,
        value: {},
      };
    },
  }));
  return (
    <Section title="Dados pessoais">
      <Row>
        <Col>
          <Input
            placeholder="Razão social"
            value={corporateName.value}
            invalid={corporateName.invalid}
            errorMessage={corporateName.errorMessage}
            onChange={handleChange(setCorporateName)}
            validations={[required]}
            ref={corporateNameRef}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            placeholder="CNPJ"
            value={cnpj.value}
            invalid={cnpj.invalid}
            errorMessage={cnpj.errorMessage}
            validations={[required, validCnpj]}
            onChange={handleChange(setCnpj)}
            mask={masks.cnpj}
            maxLength="18"
            ref={cnpjRef}
          />
        </Col>
      </Row>
      <Row columns={2}>
        <Col>
          <Autocomplete
            options={[]}
            placeholder="Atividade principal"
            onSelect={handleChange(setActivity)}
            selected={activity.value}
            invalid={activity.invalid}
            validations={[required]}
            errorMessage={activity.errorMessage}
            inputRef={activityRef}
          />
        </Col>
        <Col>
          <Autocomplete
            options={[]}
            placeholder="Faturamento"
            selected={income.value}
            invalid={income.invalid}
            errorMessage={income.errorMessage}
            onSelect={handleChange(setIncome)}
            validations={[required]}
            inputRef={incomeRef}
          />
        </Col>
      </Row>
    </Section>
  );
};

export default forwardRef(PersonalDataPJ);
